import { useState } from "react";
import { cadastrarPeriodoService } from "../../../services/cadastrarPeriodoService";

export const useAdicionarPeriodo = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const resetError = () => setError(null); // Função para resetar o erro

  const adicionar = async (valuesMaisPeriodo: any, cotaId: number) => {
    setIsLoading(true);
    const periodoData = {
      checkIn: valuesMaisPeriodo.checkIn,
      checkOut: valuesMaisPeriodo.checkOut,
      dataEspecial: valuesMaisPeriodo.dataEspecial,
      valor: valuesMaisPeriodo.valor,
      cotaId: cotaId,
      origem: 0,
    };

    try {
      if (!valuesMaisPeriodo.checkIn && !valuesMaisPeriodo.checkOut) {
        setError("Favor acertar período.");
      } else {
        const periodo = await cadastrarPeriodoService(periodoData);
        if (periodo) {
          setSuccess("Período adicionado com sucesso!");
        }
      }
    } catch (error) {
      setError("Não foi possível adicionar periodo, tente novamente!");
    } finally {
      setIsLoading(false);
    }
  };

  return { adicionar, isLoading, error, success, resetError };
};
